import { ModalAction } from "@/components/common/ModalAction";
import { UserForm } from "../user-form";
import PersonAdd from "@mui/icons-material/PersonAdd";
import { AxiosError, TSupplier, createUser } from "@/api";
import { useCallback } from "react";
import {
  RecordContextProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";

export const SupplierCreateUserModalAction = () => {
  const supplier = useRecordContext<TSupplier>();
  const notify = useNotify();
  const refresh = useRefresh();

  const onSubmit = useCallback(
    async (values: any, onClose: Function) => {
      const payload = {
        ...values,
        supplierId: supplier.id,
        phone: values.phonePrefix + values.phone,
      };
      // Remove phonePrefix from payload as backend only expects phone
      delete payload.phonePrefix;
      try {
        await createUser(payload);
        notify("El usuario fue creado correctamente.", {
          type: "success",
        });
        refresh();
        onClose();
      } catch (error: any) {
        let errorMessage;
        if (error.code === "auth/email-already-in-use") {
          errorMessage = "El correo ingresado ya existe";
        }
        if (error.code === "auth/weak-password") {
          errorMessage =
            "La contraseña es insegura, por favor ingresa números y caracteres";
        }
        if (error.code === "auth/invalid-email") {
          errorMessage = "El correo es inválido";
        }

        if (error instanceof AxiosError) {
          errorMessage = error.response?.data?.message;
        }

        notify(errorMessage || "Error al crear el usuario.", {
          type: "warning",
        });
      }
    },
    [supplier, notify, refresh]
  );

  return (
    <ModalAction
      buttonText="Crear usuario"
      buttonIcon={<PersonAdd />}
      buttonVariant="text"
      dialogTitle="Crear nuevo usuario"
      dialogContent={(onClose) => (
        <RecordContextProvider value={undefined}>
          <UserForm
            onSubmit={(values) => onSubmit(values, onClose)}
            supplierId={supplier.id}
          />
        </RecordContextProvider>
      )}
    />
  );
};
